import React from 'react';
import { Loader } from 'lucide-react';

const LoadingSpinner = ({ message = 'Loading...', fullScreen = true }) => {
    if (fullScreen) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="text-center">
                    <Loader className="w-12 h-12 text-purple-600 animate-spin mx-auto mb-4" />
                    <p className="text-gray-600">{message}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="flex items-center justify-center p-8">
            <div className="text-center">
                <Loader className="w-8 h-8 text-purple-600 animate-spin mx-auto mb-2" />
                <p className="text-sm text-gray-600">{message}</p>
            </div>
        </div>
    );
};

export default LoadingSpinner;